import { ConfigTranslatedText } from '@/eventConfig/types.ts';
import { i18n } from '@/translation/TranslationProvider.tsx';
import { isNil } from 'ramda';

export const translate = (text?: ConfigTranslatedText | string): string => {
  if (isNil(text)) {
    return '';
  }
  if (!text || typeof text === 'string') {
    return text;
  }

  const fallbackLanguage = Object.keys(text)[0] as 'en' | 'de' | 'es' | 'pl';
  return text[i18n.locale] || '⚠️' + text[fallbackLanguage] + '⚠️';
};
